export const COMPANY = {};

//-------------------------------------------------------------------
COMPANY.SET_CURRENT_COMPANY = "SET_CURRENT_COMPANY";
COMPANY.SET_CURRENT_PROJECT = "SET_CURRENT_PROJECT";
COMPANY.SET_PROJECT_LIST = "SET_PROJECT_LIST";
